import moment from 'moment';

export const formatDateToDisplay = (dateString, defaultFormat = 'DD/MM/YYYY') => {
  if (!dateString) return '';

  const date = moment.utc(dateString);
  if (!date.isValid()) return '';

  return date.format(defaultFormat);
};